class InputColorHex {
    constructor(element) {
        this.element = element;
        this.groupColor = (this.element) ? this.element.nextElementSibling : null;
        this.init();
    }

    attachListeners() {
        if (this.groupColor) {
            this.element.addEventListener('input', () => {
                this.groupColor.textContent = this.element.value.toUpperCase();
            });
            this.element.dispatchEvent(new Event('input'));
        }
    }

    value() {
        return this.element.value;
    }

    val() {
        return this.value();
    }

    init() {
        this.attachListeners();
    }
}

// Inisialisasi class setelah DOM siap
document.addEventListener('DOMContentLoaded', () => {
    new InputColorHex();
});

export default InputColorHex;
